var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccept(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 196.431,
    height: 85.123,
    viewBox: "0 0 196.431 85.123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d,.f,.g{fill:#fff;}.a,.e,.f,.h{stroke:#47a882;}.a{stroke-dasharray:2;}.b{fill:#87eac3;}.c{fill:#47a882;}.e,.h,.j{fill:none;}.h{stroke-width:2px;}.i,.k{stroke:none;}.k{fill:#64a15f;}.l{filter:url(#d);}.m{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#87eac3",
    result: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "e"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#67c9a2",
    result: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "e"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-596 -304.092)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(727.724 334.543)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 27.336,
    cy: 27.336,
    r: 27.336
  }), /*#__PURE__*/React.createElement("circle", {
    className: "j",
    cx: 27.336,
    cy: 27.336,
    r: 26.836
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(760.943 322.086)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 14.879,
    cy: 14.879,
    r: 14.879
  }), /*#__PURE__*/React.createElement("circle", {
    className: "j",
    cx: 14.879,
    cy: 14.879,
    r: 14.379
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(598.309 307.553)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 23.53,
    cy: 23.53,
    r: 23.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "j",
    cx: 23.53,
    cy: 23.53,
    r: 23.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(623.223 323.47)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "i",
    cx: 21.108,
    cy: 21.454,
    rx: 21.108,
    ry: 21.454
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "j",
    cx: 21.108,
    cy: 21.454,
    rx: 20.608,
    ry: 20.954
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(645.369 358.765)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 15.225,
    cy: 15.225,
    r: 15.225
  }), /*#__PURE__*/React.createElement("circle", {
    className: "j",
    cx: 15.225,
    cy: 15.225,
    r: 14.725
  })), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 114.23,
    height: 70.175,
    rx: 6,
    transform: "translate(640.319 304.092)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 123.587,
    height: 5.458,
    rx: 2.729,
    transform: "translate(635.251 373.098)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0H134.893a0,0,0,0,1,0,0V0a6.628,6.628,0,0,1-6.628,6.628H6.628A6.628,6.628,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(629.013 375.827)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 106.043,
    height: 62.378,
    rx: 6,
    transform: "translate(644.607 307.991)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "m",
    transform: "matrix(1, 0, 0, 1, 596, 304.09)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 106.043,
    height: 62.378,
    rx: 6,
    transform: "translate(48.61 3.9)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(644.607 307.991)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 106.043,
    height: 62.378,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    x: 0.5,
    y: 0.5,
    width: 105.043,
    height: 61.378,
    rx: 5.5
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H33.918L32.155,3.509H2.4Z",
    transform: "translate(679.695 375.827)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "l",
    transform: "matrix(1, 0, 0, 1, 596, 304.09)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,0H33.918L32.155,3.509H2.4Z",
    transform: "translate(83.7 71.73)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M3.025,0H99.078A3.073,3.073,0,0,1,102.1,3.119V24.951a3.073,3.073,0,0,1-3.025,3.119H82.524v10.2L67.211,28.07H3.025A3.073,3.073,0,0,1,0,24.951V3.119A3.073,3.073,0,0,1,3.025,0Z",
    transform: "translate(609.561 325.145)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.025,0H99.078A3.073,3.073,0,0,1,102.1,3.119V24.951a3.073,3.073,0,0,1-3.025,3.119H82.524v10.2L67.211,28.07H3.025A3.073,3.073,0,0,1,0,24.951V3.119A3.073,3.073,0,0,1,3.025,0Z",
    transform: "translate(607.292 322.806)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 41.326,
    height: 3.119,
    rx: 1.559,
    transform: "translate(640.319 343.858)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 28.07,
    height: 3.119,
    rx: 1.559,
    transform: "translate(640.319 333.332)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 20.663,
    height: 3.119,
    rx: 1.559,
    transform: "translate(640.319 327.874)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 44.055,
    height: 3.119,
    rx: 1.559,
    transform: "translate(640.319 338.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 34.698,
    height: 3.119,
    rx: 1.559,
    transform: "translate(670.728 333.332)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 18.713,
    height: 3.119,
    rx: 1.559,
    transform: "translate(686.713 338.4)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(614.978 327.874)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M115.14,229.89h1.051a1.2,1.2,0,0,0,.152.03,8.1,8.1,0,0,1,2.643.614,8.858,8.858,0,0,1,5.506,6.8c.065.33.093.667.138,1v1.051a1.2,1.2,0,0,0-.03.151,8.3,8.3,0,0,1-1.025,3.532,8.8,8.8,0,0,1-7.535,4.743,8.213,8.213,0,0,1-4.565-1.033,8.788,8.788,0,0,1-4.762-7.54,8.31,8.31,0,0,1,1.038-4.582,8.833,8.833,0,0,1,6.351-4.621C114.445,229.966,114.795,229.936,115.14,229.89Zm-1.4,11.307a2.1,2.1,0,0,0-.147-.2q-.939-.942-1.88-1.881a1.228,1.228,0,0,0-.169-.151.636.636,0,0,0-1,.558.732.732,0,0,0,.262.5q1.2,1.193,2.389,2.387a.67.67,0,0,0,1.1,0L120.5,236.2a1.234,1.234,0,0,0,.162-.183.6.6,0,0,0,.026-.677.612.612,0,0,0-.583-.318.743.743,0,0,0-.511.269q-2.845,2.848-5.691,5.694C113.858,241.039,113.819,241.1,113.74,241.2Z",
    transform: "translate(-106.698 -229.89)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "translate(782.396 367.07)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M 4.498384475708008 9.038824081420898 C 2.376384496688843 9.038824081420898 0.6500044465065002 7.157224178314209 0.6500044465065002 4.844414234161377 C 0.6500044465065002 2.531604290008545 2.376384496688843 0.6500042080879211 4.498384475708008 0.6500042080879211 C 6.620384693145752 0.6500042080879211 8.34676456451416 2.531604290008545 8.34676456451416 4.844414234161377 C 8.34676456451416 7.157224178314209 6.620384693145752 9.038824081420898 4.498384475708008 9.038824081420898 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M 4.498384475708008 1.300004005432129 C 2.734794616699219 1.300004005432129 1.300004482269287 2.890024185180664 1.300004482269287 4.844414234161377 C 1.300004482269287 6.79880428314209 2.734794616699219 8.388824462890625 4.498384475708008 8.388824462890625 C 6.261974334716797 8.388824462890625 7.696764469146729 6.79880428314209 7.696764469146729 4.844414234161377 C 7.696764469146729 2.890024185180664 6.261974334716797 1.300004005432129 4.498384475708008 1.300004005432129 M 4.498384475708008 3.814697265625e-06 C 6.98277473449707 3.814697265625e-06 8.996764183044434 2.168914318084717 8.996764183044434 4.844414234161377 C 8.996764183044434 7.519914150238037 6.98277473449707 9.688824653625488 4.498384475708008 9.688824653625488 C 2.013994693756104 9.688824653625488 4.76837158203125e-06 7.519914150238037 4.76837158203125e-06 4.844414234161377 C 4.76837158203125e-06 2.168914318084717 2.013994693756104 3.814697265625e-06 4.498384475708008 3.814697265625e-06 Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 196.431,
    transform: "translate(596 382.612)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H14.533V10.035A7.267,7.267,0,0,1,0,10.035Z",
    transform: "translate(773.4 364.994)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M14.567,0V12.08a5.228,5.228,0,0,1-5.2,5.252H5.2C2.329,17.332.11,13.669.11,10.768c0,0,5.2,1.842,8.841-1.178S14.567,0,14.567,0Z",
    transform: "translate(773.4 365.018)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccept);
export default __webpack_public_path__ + "static/media/Accept.2366a73c05f976f5c125462f2ec5141f.svg";
export { ForwardRef as ReactComponent };